export enum SignInProvider {
	GOOGLE = 'GOOGLE',
	FACEBOOK = 'FACEBOOK',
	APPLE = 'APPLE',
}
